import styles from "./styles.module.scss"
import cn from "clsx"
import { Arrow } from "./Arrow"
import type { FC, HTMLAttributes } from "react"


interface ItemProps
extends HTMLAttributes<HTMLLIElement> {}

export const Item: FC<ItemProps> = ({ className, children, ...rest }) => (
  <li className={cn(styles.item, className)} {...rest}>
    <Arrow />
    {children}
  </li>
)
